export const FILTERING_PROPERTIES = [
    {
        propertyLabel: 'Queue',
        key: 'queueName',
        groupValuesLabel: 'Queue',
        operators: [':', '!:', '=', '!='] as const,
    },
] as const;
